import { ApolloError } from '@apollo/client'; // Ensure Apollo Client is used
import { InstitutionalInformation as schemaInstitutionalInformation } from './schemas';
import apiClient from './apiClient';
import InstitutionalInformationDataStore from '../../datastores/InstitutionalInformationDataStore';

class InstitutionalInformationDataStoreGraphQL
  implements InstitutionalInformationDataStore
{
  async getInstitutionalInformation(
    campus: string,
    career: string,
    zona: string
  ) {
    try {
      const client = apiClient();
      const response = await client.query({
        query: schemaInstitutionalInformation.InstitutionalInformation,
        variables: {
          campus,
          career,
          zona
        }
      });
      return response.data;
    } catch (error) {
      if (error instanceof ApolloError) {
        throw error; // Rethrow the original error
      }
      throw new Error(`Failed to fetch institutional information: ${error}`);
    }
  }
}

export default InstitutionalInformationDataStoreGraphQL;
